module.exports = __webpack_public_path__ + "assets/img/2021_2.1e856d9f.png";